import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import ApiService from "../../services/api-service";
import { buildSocialProofLine, socialProofCache } from "../../utils/gamification/socialProof";

// One quiet line under a title: "237 listening now · 1,200 saved · 80 % completed".
// Renders nothing until data arrives, and nothing at all when there is nothing to say.
export default function SocialProofLine({ type, id, sx }) {
  const [line, setLine] = useState("");

  useEffect(() => {
    if (!type || !id) return undefined;
    let alive = true;
    socialProofCache
      .get(type, id, () => ApiService.SOCIAL_PROOF_ASSET(type, id).then((res) => res?.result ?? res))
      .then((data) => alive && setLine(buildSocialProofLine(data)))
      .catch((error) => console.warn("[SocialProofLine] unavailable", type, id, error?.message));
    return () => {
      alive = false;
    };
  }, [type, id]);

  if (!line) return null;
  return (
    <Typography component="p" sx={{ fontSize: 12, color: "#8A8A8A", lineHeight: 1.4, letterSpacing: "0.01em", m: 0, ...sx }}>
      {line}
    </Typography>
  );
}
